import { render } from "./ButtonRank3.vue?vue&type=template&id=32a31cac&scoped=true"
const script = {}

import "./ButtonRank3.vue?vue&type=style&index=0&id=32a31cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a31cac"]])

export default __exports__